import { render, staticRenderFns } from "./PurchaseInvoiceExtract.vue?vue&type=template&id=42984b3e&scoped=true"
import script from "./PurchaseInvoiceExtract.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceExtract.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoiceExtract.vue?vue&type=style&index=0&id=42984b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42984b3e",
  null
  
)

export default component.exports